type CurrencyType = '₹' | '$' | '€';

export const currency: CurrencyType = '$';

export const currentYear = new Date().getFullYear();

export const credits = {
  website: 'https://venetronic.com/',
  name: 'Venetronic',
  buyLink: '/greeva-angular/',
};

export const basePath: string = '/';

export const companyUuid: string = 'b08cab3f-3efc-40d0-80ee-719f6cd9d175';
export const roleMasterUuid: string = '11c550c0-9ffa-11f0-98e9-abc2cbb42392';
